<ng-container>
  @if (templateName === 'template-single') {
    <template-single [segmentIdOverride]="segmentIdOverride"></template-single>
  }
  @if (templateName === 'template-404') {
    <template-404></template-404>
  }
</ng-container>
